import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const leantime = defineConnector({
  identifier: "leantime",
  name: "Leantime",
  tagLine: "Open-source project management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Leantime details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://leantime.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Leantime instance.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Leantime, go to **Company Settings → API** and create an API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/jsonrpc`,
  },
});
